import { ChartNetwork, ChartNoAxesColumn, ContactRound, Files, Home, User, Users, Plus, ClipboardList, Package } from "lucide-react";
import { ModeToggle } from "./mode-toggle";
import { Link } from "@tanstack/react-router";
import Notifications from "@/dashboard/notifications";
import { useAuth } from "@/context/AuthContext";
import { memo, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { OfflineIndicator } from "./offline/OfflineIndicator";

const tagLinkClass = "flex flex-col items-center text-gray-600 dark:text-gray-400 hover:text-blue-500 dark:hover:text-blue-400 transition-colors duration-200 text-base";
const activeLinkStyle = "bg-blue-500/90 dark:bg-blue-600/90 text-white rounded-xl px-3 py-2 shadow-lg";

const NavMobile = memo(() => {
    const styleIcons = "w-6 h-6";
    const { userRoles, user } = useAuth();
    const [isOpen, setIsOpen] = useState(false);

    const extraItems = [
        { to: "/instruments/listInstruments", icon: Package, label: "Instrumentos", show: !!(userRoles?.isAdmin || userRoles?.isServicioTecnico) },
        { to: "/myProfile", icon: User, label: "Perfil", show: true },
        { to: "/directory", icon: Users, label: "Directorio", show: true },
        { to: "/activity", icon: ChartNoAxesColumn, label: "Actividad", show: true },
    ].filter(item => item.show);

    return (
        <div>
            {/* <div className="absolute top-7 right-5 lg:hidden items-end space-x-2">
                <Notifications />
                <ModeToggle />
            </div> */}

            <div className="absolute top-7 right-5 lg:hidden flex items-center space-x-1">
                <OfflineIndicator />
                <Notifications />
                <ModeToggle />
            </div>


            <nav className="fixed inset-x-0 bottom-0 rounded-t-3xl p-4 z-50 bg-white/80 dark:bg-gray-950/80 backdrop-blur-2xl backdrop-saturate-150 border-t border-gray-200/50 dark:border-gray-700/50 flex justify-around items-center pb-8 shadow-2xl lg:hidden">

                {/* Iconos principales */}
                <Link to="/dashboard" className={tagLinkClass} activeProps={{ className: activeLinkStyle }}>
                    <Home className={styleIcons} />
                </Link>
                <Link to="/requests" className={tagLinkClass} activeProps={{ className: activeLinkStyle }}>
                    <Files className={styleIcons} />
                </Link>

                <Link to="/workLog" className={tagLinkClass} activeProps={{ className: activeLinkStyle }}>
                    <ChartNetwork className={styleIcons} />
                </Link>

                {(userRoles?.isAsesorComercial || userRoles?.isServicioTecnico) && (
                    <Link
                        to="/visitLog/$id"
                        params={{ id: user?.$id || '' }}
                        className={tagLinkClass}
                        activeProps={{ className: activeLinkStyle }}
                    >
                        <ClipboardList className={styleIcons} />
                    </Link>
                )}


                {(userRoles?.isAdmin || userRoles?.isRRHH) && (
                    <Link
                        to="/assistance"
                        className={tagLinkClass}
                        activeProps={{ className: activeLinkStyle }}
                    >
                        <ContactRound className={styleIcons} />
                    </Link>
                )}
                {/* menu expandible */}
                <div className="relative">
                    {/* Items expandibles */}
                    <AnimatePresence>
                        {isOpen && extraItems.map((item, index) => (
                            <motion.div
                                key={item.to}
                                initial={{ opacity: 0, y: 20, scale: 0.8 }}
                                animate={{
                                    opacity: 1,
                                    y: -(60 + index * 70),
                                    scale: 1
                                }}
                                exit={{ opacity: 0, y: 20, scale: 0.8 }}
                                transition={{
                                    type: "spring",
                                    stiffness: 300,
                                    damping: 20,
                                    delay: index * 0.05
                                }}
                                className="absolute bottom-0 left-1/2 -translate-x-1/2"
                            >
                                <Link
                                    to={item.to}
                                    className="flex flex-col items-center gap-1"
                                    onClick={() => setIsOpen(false)}
                                >
                                    <div className="bg-linear-to-br from-blue-500 to-indigo-600 dark:from-blue-600 dark:to-indigo-700 p-3 rounded-2xl shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-200">
                                        <item.icon className="w-5 h-5 text-white" />
                                    </div>
                                    <span className="text-[10px] font-medium text-gray-800 dark:text-gray-200 whitespace-nowrap">
                                        {item.label}
                                    </span>
                                </Link>
                            </motion.div>
                        ))}
                    </AnimatePresence>

                    {/* Botón principal */}
                    <motion.button
                        onClick={() => setIsOpen(!isOpen)}
                        className={`relative ${tagLinkClass}`}
                        whileTap={{ scale: 0.9 }}
                    >
                        <motion.div
                            className={`rounded-2xl p-3 shadow-lg ${isOpen
                                ? 'bg-slate-700 dark:bg-slate-800'
                                : 'bg-linear-to-br from-blue-500 to-indigo-600 dark:from-blue-600 dark:to-indigo-700'
                                }`}
                            animate={{ rotate: isOpen ? 45 : 0 }}
                            transition={{ type: "spring", stiffness: 200 }}
                        >
                            {isOpen ? (
                                <Plus className="w-5 h-5 text-white" />
                            ) : (
                                <Plus className="w-5 h-5 text-white" />
                            )}
                        </motion.div>
                    </motion.button>

                    {/* backdrop cuando esta abierto */}
                    <AnimatePresence>
                        {isOpen && (
                            <motion.div
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                onClick={() => setIsOpen(false)}
                                className="fixed inset-0 bg-slate-300 dark:bg-slate-800 backdrop-blur-sm -z-10"
                            />
                        )}
                    </AnimatePresence>
                </div>
            </nav>
        </div>
    );
});

NavMobile.displayName = 'NavMobile';

export default NavMobile;